import React, { useState, useEffect } from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import { formatNumber, convertToFloat, convertToInt } from '../../../../utils';
import { InputAdornment } from '@material-ui/core';
import messages from '../../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import StageDetailsLogo from './StageDetailsLogo';

const useStyles = makeStyles((theme: any) => ({
  field: {
    '& .MuiInputBase-input': {
      textAlign: 'center',
      marginLeft: ({ stage }: any) => {
        if (stage.amount?.length < 4) {
          return 'inherit';
        } else if (stage.amount?.length < 7) {
          return -theme.spacing(0.5);
        } else {
          return -theme.spacing(1);
        }
      },
    },
  },
  img: { paddingBottom: theme.spacing(0.5) },
}));

export default function StageAmountEdit({
  stage,
  handleStageUpdate,
  addOrDeleteError,
}) {
  const mobile = useMobile('sm');
  const classes = useStyles({ stage });
  const [newAmount, setNewAmount] = useState('');
  const [error, setError] = useState(false);
  const currentAmount = newAmount ? convertToFloat(newAmount) : stage.amount;
  validateAmount(currentAmount, false);

  useEffect(() => {
    setNewAmount(stage.amount ? formatNumber(stage?.amount) : '');
  }, [stage]);

  function validateAmount(amount: number, markFieldRedOnErr = true) {
    const ERROR_KEY = 'stage.' + stage.id + '.amount';
    if (amount <= 0) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        ERROR_KEY,
        messages.lines.lineEditErrors.stageAmountValidNum,
      );
    } else if (isNaN(amount)) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        ERROR_KEY,
        messages.lines.lineEditErrors.stageAmountValidNum,
      );
    } else {
      markFieldRedOnErr && setError(false);
      addOrDeleteError(false, ERROR_KEY);
    }
  }

  function handleAmountChange(event) {
    const number = event.target.value.split('.');
    let newAmount = convertToFloat(number[0]);
    if (!Number.isInteger(newAmount)) {
      newAmount = 0;
    }
    let amountAsString: string = newAmount
      ? formatNumber(newAmount)
      : newAmount.toString();
    const numberHasDecimal = number.length > 1;
    if (numberHasDecimal) {
      let decimal: string | number = convertToInt(number[1].substring(0, 2));
      if (!Number.isInteger(decimal)) {
        decimal = '';
      }
      amountAsString += '.' + decimal;
    }
    setNewAmount(amountAsString);
    const amountAsNumber = convertToFloat(amountAsString);
    validateAmount(amountAsNumber);
    handleStageUpdate(stage.id, 'amount', amountAsNumber, true);
  }

  return (
    <TextField
      label={mobile ? 'Cost estimate' : null}
      className={mobile ? null : classes.field}
      variant={mobile ? 'outlined' : 'standard'}
      value={newAmount}
      error={error}
      onChange={handleAmountChange}
      InputProps={{
        name: 'stageValue',
        startAdornment: (
          <InputAdornment position="start" className={classes.img}>
            <StageDetailsLogo imgSrc="general/money_sign.svg" altText="" />
          </InputAdornment>
        ),
      }}
    />
  );
}
